import { useDispatch, useSelector } from "react-redux";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../../Components/InputAHSF";
import TextAreaAHSF from "../../../../Components/TextAreaAHSF";
import "./style.css";
import $ from "jquery";
import { useEffect, useState } from "react";
import { GetAllPublic_ST_TimePeriod } from "../../../../Redux/Reducers/Shared/PublicTimePeriod";
import {
  AddWorkExperience,
  GetOneWorkExperience,
  UpdateWorkExperience,
} from "../../../../Redux/Reducers/Submitter/WorkExperience";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import Swal from "sweetalert2";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
import AttachmentASFH from "../../../../Components/AttachmentsAHSF";
import {
  AddVolunteerCommunityWork,
  GetOneVolunteerCommunityWork,
  UpdateVolunteerCommunityWork,
} from "../../../../Redux/Reducers/Submitter/VolunteerCommunityWork";
import { useParams } from "react-router-dom";
const VoluntaryCommunityWorkForm = (props) => {
  const [renderData, setRenderData] = useState(false);
  const TimePeriod = useSelector(
    (state) => state.PublicTimePeriod.PublicTimePeriod
  );
  const dispatch = useDispatch();
 const {ApplicationInformationId} = useParams();
  const VoluntaryCommunityWorkResult = useSelector(
    (state) => state.VolunteerCommunityWork.VolunteerCommunityWork
  );
  const lang = useSelector((state) => state.languageReducer.Language);
  const [VolunteerRole, setVolunteerRole] = useState(null);
  const [
    OrganizationInstitutionUniversity,
    setOrganizationInstitutionUniversity,
  ] = useState(null);
  const [PeriodFromYear, setPeriodFromYear] = useState(null);
  const [PeriodFromYearNumber, setPeriodFromYearNumber] = useState(null);
  const [PeriodToYearNumber, setPeriodToYearNumber] = useState(null);

  const [PeriodToYear, setPeriodToYear] = useState(null);
  const [natureOfWork, setnatureOfWork] = useState(null);
  const [PeriodFromYearText, setPeriodFromYearText] = useState(null);
  const [PeriodToYearText, setPeriodToYearText] = useState(null);
  const [
    AttachedVolunteerCertificatePath,
    setAttachedVolunteerCertificatePath,
  ] = useState(null);
  const [
    AttachedVolunteerCertificateFile,
    setAttachedVolunteerCertificateFile,
  ] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(
      GetAllPublic_ST_TimePeriod({
        academicAchievementShow: false,
        workExperiencePeriodFromYearShow: true,
        workExperiencePeriodToYearShow: false,
        volunteerCommunityWorkPeriodToYearShow: false,
        volunteerCommunityWorkPeriodFromYearShow: false,
        detailsOfResearchSubmittedForAwardLastFiveYearsShow: false,
      })
    );
  }, []);

  const ValidationFunction = () => {
    const newErrors = {};
    if (!VolunteerRole) {
      newErrors.VolunteerRole = true;
    }

    if (!OrganizationInstitutionUniversity) {
      newErrors.OrganizationInstitutionUniversity = true;
    }

    if (!PeriodFromYear) {
      newErrors.PeriodFromYear = true;
    }

    if (!PeriodToYear) {
      newErrors.PeriodToYear = true;
    }

    if (!natureOfWork) {
      newErrors.natureOfWork = true;
    }

    if (PeriodFromYearNumber && PeriodToYearNumber) {
      if (Number(PeriodToYearNumber) < Number(PeriodFromYearNumber)) {
        newErrors.PeriodToYearNumber = true;
      }
    }

    // if (AttachedVolunteerCertificatePath == null) {
    //   if (!AttachedVolunteerCertificateFile) {
    //     newErrors.AttachedVolunteerCertificateFile = true;
    //   }
    // }

    return newErrors;
  };

  const AddVoluntaryCommunityWorkFormFunction = async () => {
    const newErrors = ValidationFunction();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let newFormData = new FormData();
      newFormData.append("VolunteerRole", VolunteerRole);
      newFormData.append("Organization", OrganizationInstitutionUniversity);
      newFormData.append("PeriodFromYear_TimePeriodId", PeriodFromYear);
      newFormData.append("PeriodToYear_TimePeriodId", PeriodToYear);
      newFormData.append("NatureOfWork", natureOfWork);
      newFormData.append(
        "AttachedVolunteerCertificate",
        AttachedVolunteerCertificatePath
      );
      newFormData.append("file", AttachedVolunteerCertificateFile);
      newFormData.append(
        "ApplicationInformationId",
        localStorage.getItem("ApplicationInformationId")||
          ApplicationInformationId,
      );
      const resultAdd = await dispatch(AddVolunteerCommunityWork(newFormData));
      if (resultAdd.payload.code == 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title:
            lang == "ar"
              ? "تم إضافة المعلومات بنجاح"
              : "Information Added Successfully",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        dispatch(setRefreshTable({ tableId: "VoluntaryCommunityWork" }));
        if (
          props.setRefreshDataFromClosePageVoluntaryCommunityWork != undefined
        ) {
          if (props.refreshDataFromClosePageVoluntaryCommunityWork == false) {
            props.setRefreshDataFromClosePageVoluntaryCommunityWork(true);
          } else {
            props.setRefreshDataFromClosePageVoluntaryCommunityWork(false);
          }
        }
        $(".close-btn").trigger("click");
      }
    }
  };

  const GetData = async () => {
    if (props.FormStatus == "Edit") {
      var result = await dispatch(
        GetOneVolunteerCommunityWork({
          volunteerCommunityWorkId: props.volunteerCommunityWorkId,
        })
      );

      if (result.payload.code == 200) {
        console.log(result?.payload?.result, "sssssssssssssdwdwd");

        setVolunteerRole(result?.payload?.result?.volunteerRole);
        setOrganizationInstitutionUniversity(
          result?.payload?.result?.organization
        );
        setPeriodFromYear(result?.payload?.result?.periodFromYear_TimePeriodId);
        setPeriodToYear(result?.payload?.result?.periodToYear_TimePeriodId);
        setnatureOfWork(result?.payload?.result?.natureOfWork);

        setPeriodFromYearText(
          result?.payload?.result?.periodFromYear_TimePeriod?.timePeriodNumber
        );
        setPeriodFromYearNumber(
          result?.payload?.result?.periodFromYear_TimePeriod?.timePeriodNumber
        );
        setPeriodToYearNumber(
          result?.payload?.result?.periodToYear_TimePeriod?.timePeriodNumber
        );
        setPeriodToYearText(
          result?.payload?.result?.periodToYear_TimePeriod?.timePeriodNumber
        );
        setAttachedVolunteerCertificatePath(
          result?.payload?.result?.attachedVolunteerCertificate
        );
        setRenderData(true);
      }
    }
  };

  useEffect(() => {
    GetData();
  }, [props.workExperienceId]);
  // console.log(VoluntaryCommunityWorkResult?.result?.volunteerCommunityWorkId,"VoluntaryCommunityWorkResultVoluntaryCommunityWorkResult");

  console.log(
    AttachedVolunteerCertificatePath,
    "AttachedVolunteerCertificatePath"
  );

  const EditFunction = async () => {
    const newErrors = ValidationFunction();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let newFormData = new FormData();
      newFormData.append("VolunteerRole", VolunteerRole);
      newFormData.append(
        "VolunteerCommunityWorkId",
        VoluntaryCommunityWorkResult?.result?.volunteerCommunityWorkId
      );
      newFormData.append("Organization", OrganizationInstitutionUniversity);
      newFormData.append("PeriodFromYear_TimePeriodId", PeriodFromYear);
      newFormData.append("PeriodToYear_TimePeriodId", PeriodToYear);
      newFormData.append("NatureOfWork", natureOfWork);

      newFormData.append(
        "AttachedVolunteerCertificate",
        AttachedVolunteerCertificatePath
      );

      newFormData.append("file", AttachedVolunteerCertificateFile);
      newFormData.append(
        "ApplicationInformationId",
        VoluntaryCommunityWorkResult?.result?.applicationInformationId
      );
      const result = await dispatch(UpdateVolunteerCommunityWork(newFormData));
      if (result.payload.code == 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title:
            lang == "ar"
              ? "تم تعديل المعلومات بنجاح"
              : "Information Updated Successfully",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        dispatch(setRefreshTable({ tableId: "VoluntaryCommunityWork" }));
        if (
          props.setRefreshDataFromClosePageVoluntaryCommunityWork != undefined
        ) {
          if (props.refreshDataFromClosePageVoluntaryCommunityWork == false) {
            props.setRefreshDataFromClosePageVoluntaryCommunityWork(true);
          } else {
            props.setRefreshDataFromClosePageVoluntaryCommunityWork(false);
          }
        }
        $(".close-btn").trigger("click");
      }
    }
  };
  console.log(AttachedVolunteerCertificatePath, "sssssssssssssdwdwd");

  const HTML = (
    <>
      <div className="form-grid-custom-practicalExperiences">
        <div>
          <InputAHSF
            fieldsName="VolunteerRole"
            show={true}
            lang={lang}
            disabled={props.disabled}
            defaultValue={VolunteerRole}
            onChange={(e) => {
              setVolunteerRole(e.target.value);
            }}
            showValidationMessage={errors.VolunteerRole}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        <div>
          <InputAHSF
            fieldsName="OrganizationInstitutionUniversity"
            show={true}
            lang={lang}
            disabled={props.disabled}
            defaultValue={OrganizationInstitutionUniversity}
            onChange={(e) => {
              setOrganizationInstitutionUniversity(e.target.value);
            }}
            showValidationMessage={errors.OrganizationInstitutionUniversity}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        <div>
          <AllDropDownsAHSF
            fieldsName="PeriodFromYear"
            hidelable={false}
            //   labelName={"الجنسية"}
            disabled={props.disabled}
            lang={lang}
            show={true}
            valueEdite={PeriodFromYear}
            submissionStatus={"edite"}
            textEdite={PeriodFromYearText}
            arrayOoptionList={TimePeriod}
            KeyText={lang === "ar" ? "timePeriodNumber" : "timePeriodNumber"}
            id={"timePeriodId"}
            dropdownType={"search"}
            defaultValue={PeriodFromYear}
            value={PeriodFromYear}
            OnClickLi={(e) => {
              setPeriodFromYear(e.timePeriodId);
              setPeriodFromYearNumber(e.timePeriodNumber);
            }}
            onClickInput={() => {
              dispatch(
                GetAllPublic_ST_TimePeriod({
                  academicAchievementShow: false,
                  workExperiencePeriodFromYearShow: false,
                  workExperiencePeriodToYearShow: false,
                  volunteerCommunityWorkPeriodToYearShow: false,
                  volunteerCommunityWorkPeriodFromYearShow: true,
                  detailsOfResearchSubmittedForAwardLastFiveYearsShow: false,
                })
              );
            }}
            showValidationMessage={errors.PeriodFromYear}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        <div>
          <AllDropDownsAHSF
            fieldsName="PeriodToYear"
            hidelable={false}
            //   labelName={"الجنسية"}
            disabled={props.disabled}
            lang={lang}
            show={true}
            valueEdite={PeriodToYear}
            submissionStatus={"edite"}
            textEdite={PeriodToYearText}
            arrayOoptionList={TimePeriod}
            KeyText={lang === "ar" ? "timePeriodNumber" : "timePeriodNumber"}
            id={"timePeriodId"}
            dropdownType={"search"}
            defaultValue={PeriodToYear}
            value={PeriodToYear}
            OnClickLi={(e) => {
              setPeriodToYear(e.timePeriodId);
              setPeriodToYearNumber(e.timePeriodNumber);
            }}
            onClickInput={() => {
              dispatch(
                GetAllPublic_ST_TimePeriod({
                  academicAchievementShow: false,
                  workExperiencePeriodFromYearShow: false,
                  workExperiencePeriodToYearShow: false,
                  volunteerCommunityWorkPeriodToYearShow: true,
                  volunteerCommunityWorkPeriodFromYearShow: false,
                  detailsOfResearchSubmittedForAwardLastFiveYearsShow: false,
                })
              );
            }}
            showValidationMessage={
              errors.PeriodToYear || errors.PeriodToYearNumber
            }
            validationMessage={
              errors.PeriodToYearNumber
                ? lang === "ar"
                  ? "الفنرة الى سنة يجب ان تكون اكبر من الفترة من سنة"
                  : "End year must be greater than start year"
                : lang === "ar"
                ? "حقل اجباري"
                : "Field Required"
            }
          />
        </div>

        <div>
          <TextAreaAHSF
            fieldsName="natureOfWork"
            show={true}
            lang={lang}
            disabled={props.disabled}
            onChange={(e) => {
              setnatureOfWork(e.target.value);
            }}
            defaultValue={natureOfWork}
            showValidationMessage={errors.natureOfWork}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        <div style={{ marginTop:"8px" }}>
          <AttachmentASFH
            show={true}
            disabled={props.disabled}
            clear={false}
            readOnly={false}
            singleFile={
              AttachedVolunteerCertificateFile == null
                ? AttachedVolunteerCertificatePath
                : AttachedVolunteerCertificateFile
            }
            onChange={(e) => {
              console.log(e.target.files[0], "eeddddeeee");

              setAttachedVolunteerCertificateFile(e.target.files[0]);
            }}
            fieldsName={"AttachedVolunteerCertificate"}
            title="المرفقات"
            id="file-2"
            lang={lang}
            showValidationMessage={errors.AttachedVolunteerCertificateFile}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        {!props.disabled ? (
          <div className="containerButtonsMAinSubmission">
            <ButtonAHSF
              type={"submitter"}
              fieldsName={`${
                props.FormStatus == "Edit" ? "EditButton" : "AddButton"
              }`}
              lang={lang}
              onClick={() => {
                if (props.FormStatus == "Edit") {
                  EditFunction();
                }
                if (props.FormStatus == "Add") {
                  AddVoluntaryCommunityWorkFormFunction();
                }
              }}
              disabled={false}
              // title={"التالي"}
              // text={"التالي"}
              show={true}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );

  if (props.FormStatus == "Edit") {
    if (
      VoluntaryCommunityWorkResult?.result?.volunteerCommunityWorkId &&
      renderData
    ) {
      return <>{HTML}</>;
    }
  } else if (props.FormStatus == "Add") {
    return <>{HTML}</>;
  }
};

export default VoluntaryCommunityWorkForm;
